import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {
  LoginComponent, NavbarComponent, AdminDashboardComponent,
  // tslint:disable-next-line:max-line-length
  EditorComponent, AdminProgramLavelComponent, AdminQuestionsComponent, CampaignListComponent, UserListComponent, HackathonQuestionComponent, SettingsComponent, CampaignDashboardComponent, AddIndividualQuestionComponent
} from './components';

import { AuthGuardGuard } from './services/authguard/auth-guard.guard';
import { DriveContainerComponent } from './components/admin-v2/drive-container/drive-container.component';
import { DriveAddBranchComponent } from './components/admin-v2/drive-add-branch/drive-add-branch.component';
import { CampaignComponent } from './components/admin-v2/campaign/campaign.component';
import { DriveComponent } from './components/admin-v2/drive/drive.component';
import { CollegeComponent } from './components/admin-v2/college/college.component';
import { CollegeDetailsComponent } from './components/admin-v2/college-details/college-details.component';
import { CampaignSettingComponent } from './components/admin-v2/campaign-setting/campaign-setting.component';
import { AttendanceComponent } from './components/admin-v2/attendance/attendance.component';
import { ViewCampaignComponent } from './components/admin-v2/view-campaign/view-campaign.component';
import { InvitationFormComponent } from './components/admin-v2/registration-form/invitation-form.component';
import { ThankYouComponent } from './components/admin-v2/thank-you/thank-you.component';
import { InvalidUrlComponent } from './components/admin-v2/invalid-url/invalid-url.component';
import { CampaignDashboardV2Component } from './components/admin-v2/campaign-dashboard-v2/campaign-dashboard-v2.component';
import { DriveDashboardV2Component } from './components/admin-v2/drive-dashboard-v2/drive-dashboard-v2.component';
import { WalkinDriveDialogboxComponent } from './components/admin-v2/walkin-drive-dialogbox/walkin-drive-dialogbox.component';
import { ExcelUploadRegistrationComponent } from './components/admin-v2/excel-upload-registration/excel-upload-registration.component';
import { ExcelDataComponent } from './components/admin-v2/excel-data/excel-data.component';
import { DownloaddatedialogComponent } from './components/admin-v2/downloaddatedialog/downloaddatedialog.component';


const routes: Routes = [
  { path: 'admin/login', component: LoginComponent },
  // {path:'dash', component:DownloaddatedialogComponent},
 
  //{ path: 'excel-data', component: ExcelDataComponent },
  
  

  { path: 'attendance/:shortName', component: AttendanceComponent },
  // { path: 'campaignDashBoard', component: CampaignDashboardV2Component },
  {
    path: 'admin', component: NavbarComponent,
    children: [
      { path: 'excel-data', component: ExcelDataComponent },
      //{ path: '',redirectTo:'campaign',pathMatch:'full'},
      //{ path: 'walkin', component:WalkinDriveDialogboxComponent, canActivate: [AuthGuardGuard] },
      { path: 'campaign', component:CampaignDashboardV2Component, canActivate: [AuthGuardGuard] },
      { path: 'drive1', component:DriveDashboardV2Component, canActivate: [AuthGuardGuard] },
      { path: 'dashboard', component: AdminDashboardComponent, canActivate: [AuthGuardGuard] },
     // { path: 'campaign-dashboard', component: CampaignDashboardComponent, canActivate: [AuthGuardGuard] },

      { path: 'mcq-settings', component: SettingsComponent, canActivate: [AuthGuardGuard] },

      //  { path: 'mcq-settings', component: SettingsComponent },


      { path: 'level', component: AdminProgramLavelComponent, canActivate: [AuthGuardGuard] },
      { path: 'campaignlist', component: CampaignListComponent, canActivate: [AuthGuardGuard] },
      { path: 'userlist', component: UserListComponent, canActivate: [AuthGuardGuard] },

     // { path: 'campaign', component: CampaignComponent, canActivate: [AuthGuardGuard] },
      { path: 'collegeDetails/:type/:id', component: CollegeDetailsComponent, canActivate: [AuthGuardGuard] },
      { path: 'drive', component: DriveComponent,canActivate: [AuthGuardGuard] },
      { path: 'college/:type', component: CollegeComponent },
      { path: 'drive-container/:type/:id', component: DriveContainerComponent },
      { path: 'online-campaign', component: ViewCampaignComponent, canActivate: [AuthGuardGuard] },
      { path: 'campaign-settings', component: CampaignSettingComponent },
      { path: 'questions', component: AdminQuestionsComponent },
      {path:'excel-upload',component:ExcelUploadRegistrationComponent}
    ]
  },
  { path: 'editor', component: EditorComponent, canActivate: [AuthGuardGuard] },
  { path: 'hackathonquestions', component: HackathonQuestionComponent, canActivate: [AuthGuardGuard] },
  { path: '', redirectTo: 'admin/login', pathMatch: 'full' },
 // { path: 'questions', component: AdminQuestionsComponent, canActivate: [AuthGuardGuard] },
  {path:'register/:shortName',component:InvitationFormComponent},
  {path:'thank-you',component:ThankYouComponent},
  {path:'not-found',component:InvalidUrlComponent} ,

  // { path: '**', component: LoginComponent }


];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  
  exports: [RouterModule],
  declarations: []
})

export class AppRoutingModule { }
